import { SeverityLevel } from '@microsoft/applicationinsights-web'
import { getAppInsights } from '../helpers/createAppInsights'


export function event(name, properties = {}) {
    getAppInsights().trackEvent({ name, properties })
}

export function trace(message, properties = {}) {
    getAppInsights().trackTrace({
        message,
        severityLevel: SeverityLevel.Info,
        properties
    })
}

export function report(exception, properties = {}) {
    getAppInsights().trackException({
        exception,
        severityLevel: SeverityLevel.Error,
        properties
    })
}

export function track(name, pageType = 'conent', properties = {}) {
    getAppInsights().trackPageView({
        name,
        pageType,
        properties
    })
}